export default require('./TabPlaylist').default
